export default __webpack_public_path__ + "static/media/report-problem.c4237c8d.svg";